(function () {

    'use strict';

    angular.module('itxApp.cmsPage', []);
    angular.module('itxApp.preCommon', []);
    angular.module('itxApp.catalog', []);
 
})();
